var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "84px",
    viewBox: "0 0 85 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_ar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ficha",
    transform: "translate(-2005, -1045)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_ar",
    transform: "translate(2008, 1047)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "25.516666 29 39.016666 38 52.516666 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.516666,80 L37.6275275,72.4023053 C38.4825699,71.8658982 39.5507621,71.8658982 40.4058046,72.4023053 L52.516666,80 L52.516666,80",
    id: "Path-2-Copy",
    transform: "translate(39.0167, 76) scale(-1, 1) rotate(-180) translate(-39.0167, -76)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.016666,
    y1: 67,
    x2: 39.016666,
    y2: 78,
    id: "Path-3-Copy",
    transform: "translate(39.0167, 72.5) scale(-1, 1) rotate(-180) translate(-39.0167, -72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.516666,8 L36.2383889,0.854737132 C37.9484738,-0.284912377 40.0848582,-0.284912377 41.7949431,0.854737132 L52.516666,8 L52.516666,8",
    id: "Path-2-Copy",
    transform: "translate(39.0167, 4) rotate(-360) translate(-39.0167, -4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.016666,
    y1: 2,
    x2: 39.016666,
    y2: 13,
    id: "Path-3-Copy",
    transform: "translate(39.0167, 7.5) rotate(-360) translate(-39.0167, -7.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84459304,61.5577862 L7.43325779,55.7834774 C8.2857628,55.3045224 9.33361486,55.3210164 10.1765935,55.8266596 L20.1214004,61.7918445 L20.1214004,61.7918445",
    id: "Path-2-Copy-2",
    transform: "translate(8.6384, 58.6137) rotate(-121) translate(-8.6384, -58.6137)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.516666,
    y1: 58,
    x2: 6.51666603,
    y2: 53,
    id: "Path-3-Copy-2",
    transform: "translate(11.5167, 55.5) scale(-1, 1) translate(-11.5167, -55.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84459304,24.5323967 L7.43325779,18.7580879 C8.2857628,18.279133 9.33361486,18.295627 10.1765935,18.8012701 L20.1214004,24.7664551 L20.1214004,24.7664551",
    id: "Path-2-Copy-2",
    transform: "translate(8.6384, 21.5883) scale(-1, 1) rotate(59) translate(-8.6384, -21.5883)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.516666,
    y1: 27,
    x2: 6.51666603,
    y2: 22,
    id: "Path-3-Copy-2",
    transform: "translate(11.5167, 24.5) rotate(180) translate(-11.5167, -24.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6361847,24.5323967 L69.9140355,18.7580879 C70.7665405,18.279133 71.8143926,18.295627 72.6573712,18.8012701 L82.6021781,24.7664551 L82.6021781,24.7664551",
    id: "Path-2-Copy-2",
    transform: "translate(71.1192, 21.5883) rotate(-301) translate(-71.1192, -21.5883)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.516666,
    y1: 27,
    x2: 62.516666,
    y2: 22,
    id: "Path-3-Copy-2",
    transform: "translate(67.5167, 24.5) scale(-1, 1) rotate(-180) translate(-67.5167, -24.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6361847,59.7995444 L69.9140355,54.0252356 C70.7665405,53.5462807 71.8143926,53.5627747 72.6573712,54.0684178 L82.6021781,60.0336028 L82.6021781,60.0336028",
    id: "Path-2-Copy-2",
    transform: "translate(71.1192, 56.8554) scale(-1, 1) rotate(-121) translate(-71.1192, -56.8554)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.516666,
    y1: 57,
    x2: 62.516666,
    y2: 52,
    id: "Path-3-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.016666,
    y1: 37,
    x2: 39.016666,
    y2: 53,
    id: "Path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArWhite);
export default __webpack_public_path__ + "static/media/ar-white.a51b78f58f8a5c5a16c8ff14676affcb.svg";
export { ForwardRef as ReactComponent };